import { Button } from "@mantine/core"
import { useHttpsCallable } from "react-firebase-hooks/functions"
import { Reservation } from "../shared/reservation";
import { getFunctions } from "firebase/functions";
import { nowLiteral } from "../shared/periods";
import { CompanyContext } from "../pre_app/CompanyGateway";
import { useContext } from "react";
import { LocationContext } from "../pre_app/LocationGateway";

export default function CancelReservation({ reservation }: { reservation: Reservation }) {

  const functions = getFunctions();
  const company = useContext(CompanyContext);
  const location = useContext(LocationContext);

  const [cancelReservationCall, loading, _error] = useHttpsCallable(functions, 'cancelReservationCall')

  return <Button
    onClick={() => cancelReservationCall({ reservationId: reservation.id, companyId: company.id })}
    disabled={!!reservation.cancelledAt || reservation.start < nowLiteral(location.tz)}
    loading={loading}>
    Cancel
  </Button>
}
